/**
 * ui-renderers/widget.ts
 * Mini status widget shown when the main drawer is closed.
 */

export function updateWidgetState(data: {
  unread_messages: number;
  upcoming_deadlines: number;
  suggested_action: string | null;
}) {
  const widget     = document.getElementById('ai-mini-widget');
  const unreadEl   = document.getElementById('ai-mw-unread');
  const deadlineEl = document.getElementById('ai-mw-deadlines');
  const actionEl   = document.getElementById('ai-mw-action');

  if (!widget) return;

  const hasContent = data.unread_messages > 0 || data.upcoming_deadlines > 0 || data.suggested_action;
  const drawerOpen = document.getElementById('ai-drawer')?.classList.contains('open');
  widget.style.display = (!drawerOpen && hasContent) ? 'flex' : 'none';

  if (unreadEl) {
    unreadEl.textContent   = data.unread_messages > 0 ? '💬 ' + data.unread_messages : '';
    unreadEl.style.display = data.unread_messages > 0 ? '' : 'none';
  }
  if (deadlineEl) {
    deadlineEl.textContent   = data.upcoming_deadlines > 0 ? '⏰ ' + data.upcoming_deadlines : '';
    deadlineEl.style.display = data.upcoming_deadlines > 0 ? '' : 'none';
  }
  if (actionEl) {
    actionEl.textContent   = data.suggested_action ? data.suggested_action.slice(0, 40) : '';
    actionEl.style.display = data.suggested_action ? '' : 'none';
  }
}
